import JAM from "./Jam.Container";

export default JAM;